import Layer from './Layer';
import ResonatorsArrowsImage from '../images/ResonatorsArrowsImage';
import ResonatorsImage from '../images/ResonatorsImage';

const resonatorsLayer: Layer = {
  ArrowsImage: ResonatorsArrowsImage,
  PlaneImage: ResonatorsImage,
  anchorPositionX: 0.88,
  anchorPositionY: 0.538,
  collapsedOffsetY: -0.062,
  description: `
    Resonators for qubit readout wired through connectors. Measured shifts in the frequency of the
    resonator depend on the state of the qubit.
  `,
  name: 'Resonator plane',
  openOffsetY: -0.15,
  type: 'openable',
};

export default resonatorsLayer;
